<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('smart-detection-over-view')" v-if="permissionCodes.indexOf('033011000') !== -1">
        <i class="el-icon-damai-ic_gailan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('distribution-room-manage')" v-if="permissionCodes.indexOf('033002000') !== -1">
        <i class="el-icon-damai-ic_peidianfangguanli"></i>
        <span slot="title">场所管理</span>
      </el-menu-item>
      <el-submenu index="3" v-if="permissionCodes.indexOf('033003000') !== -1 || permissionCodes.indexOf('033004000') !== -1 || permissionCodes.indexOf('033005000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_shebeiguanli"></i>
          <span>设备管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1" @click="toNewRouter('smart-detection-gateway-manage')" v-if="permissionCodes.indexOf('033003000') !== -1">网关设备</el-menu-item>
          <el-menu-item index="3-3" @click="toNewRouter('smart-detection-power-distribution-cabinet-manage')" v-if="permissionCodes.indexOf('033004000') !== -1">探测设备</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-damai-ic_yunhangjiance"></i>
          <span>运行监测</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="5-1" @click="toNewRouter('smart-detection-threshold-monitoring')" v-if="permissionCodes.indexOf('033007000') !== -1">状态式探测器</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="5-2" @click="toNewRouter('smart-detection-state-monitoring')" v-if="permissionCodes.indexOf('033007000') !== -1">触发式探测器</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="5-3" @click="toNewRouter('smart-detection-operation-monitoring')" v-if="permissionCodes.indexOf('033007000') !== -1">配电探测器</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="5-4" @click="toNewRouter('smart-detection-pump-monitoring')" v-if="permissionCodes.indexOf('033007000') !== -1">泵探测器</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="7" @click="toNewRouter('smart-detection-alarm-record')" v-if="permissionCodes.indexOf('033009000') !== -1">
        <i class="el-icon-damai-ic_baojingguanli"></i>
        <span slot="title">报警记录</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('smart-detection-device-state')" v-if="permissionCodes.indexOf('033010000') !== -1">
        <i class="el-icon-damai-ic_shebeizhuangtairizhi"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>
      <el-menu-item index="9" @click="toNewRouter('smart-detection-log')" v-if="permissionCodes.indexOf('033011000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["smart-detection-over-view"],
  2: [
    "distribution-room-manage",
    "distribution-room-add",
    "distribution-room-modify"
  ],
  "3-4": [
    "smart-detection-environment-gateway-manage",
    "smart-detection-environment-gateway-add",
    "smart-detection-environment-gateway-modify"
  ],
  "3-2": [
    "smart-detection-voltage-gateway-manage",
    "smart-detection-voltage-gateway-add",
    "smart-detection-voltage-gateway-modify"
  ],
  "3-3": [
    "smart-detection-power-distribution-cabinet-manage",
    "smart-detection-power-distribution-cabinet-add",
    "smart-detection-power-distribution-cabinet-modify",
    'smart-detection-probe-add',
    'smart-detection-probe-add2',
    'smart-detection-regulation-add',
  ],
  '3-1': ['smart-detection-gateway-manage', 'smart-detection-gateway-add', 'smart-detection-gateway-modify'],
  '3-5': ['smart-detection-probe-manage', 'smart-detection-probe-modify'],
  '3-6': ['smart-detection-regulation-manage',  'smart-detection-regulation-modify'],
  '5-1': ['smart-detection-threshold-monitoring'],
  '5-2': ['smart-detection-state-monitoring'],
  '5-3': ["smart-detection-operation-monitoring"],
  '5-4': ['smart-detection-pump-monitoring'],
  "7": ["smart-detection-alarm-record", "smart-detection-alarm-record-add"],
  8: "smart-detection-device-state",
  9: "smart-detection-log"
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionNav.vue